module.exports = __webpack_public_path__ + "static/media/feature_icon_1.9be2bd14.png";